<template>
  <Modal v-model="questionnaireModal" :closable="false" footer-hide width="640"
    :transfer="false" :mask-closable="false" class-name="questionnaireStyle">
    <div class="content_box">
      <h2 class="header_title">{{ questionnaireInfo.questionnaireTitle }}</h2>
      <p class="text" v-html="questionnaireInfo.direction"></p>
      <div class="list_box">
        <div class="list_box_item" v-for="(item,index) in questionnaireList" :key="index">
          <h3 class="title" :class="item.mandatory === 1 ? 'required_styles' : ''">
            {{ (index + 1) + '.' + item.questionTitle }}
            <span class="ml10" v-if="item.answerContent && item.answerContent.length>0 && item.questionType === 2">
              {{ $t('key1000365') }}
              <span class="distributorThemeColor">{{ item.answerContent.length }}</span>
               {{ $t('key1000366') }}
            </span>
          </h3>
          <!--单选-->
          <RadioGroup :vertical="true" v-if="item.questionType === 1" v-model="item.radioValue" @on-change="radioChange">
            <Radio v-for="(ele,idx) in item.ymsQuestionnaireQuestionsItems" :label="ele.ymsQuestionnaireQuestionsItemId" :key="idx">
              {{ ele.itemContent }}
              <Input :placeholder="$t('key1000324')" style="width: 250px;" :class="item.otherTypeText == '' && item.mandatory == 1 ? 'input_error_style' : ''"
                v-model.trim="item.otherTypeText" v-if="ele.otherType && item.otherTalg"></Input>
            </Radio>
          </RadioGroup>
          <!--多选-->
          <template v-if="item.questionType === 2">
            <CheckboxGroup class="flex flex-direction" v-model="item.answerContent" @on-change="(list) => checkBoxChange(list, item.ymsQuestionnaireQuestionId)">
              <Checkbox v-for="(ele,idx) in item.ymsQuestionnaireQuestionsItems" :label="ele.ymsQuestionnaireQuestionsItemId" :key="idx">
                {{ ele.itemContent }}
                <Input :placeholder="$t('key1000324')" style="width: 250px;" v-model.trim="item.otherTypeText"
                  :class="item.otherTypeText == '' && item.mandatory == 1 ? 'input_error_style' : ''" v-if="ele.otherType && item.otherTalg"></Input>
              </Checkbox>
            </CheckboxGroup>
          </template>
          <!--文本-->
          <Input v-if="item.questionType === 3" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" v-model.trim="item.textareaValue"></Input>
        </div>
      </div>
    </div>
    <div class="options_btn">
      <Button style="width: 100%" type="primary" class="mb5" @click="submitBtn">{{ $t('key1000367') }}</Button>
      <Button style="width: 100%; border: none !important;" v-if="questionnaireInfo.skipOperShow" type="text" @click="skipBtn">{{ $t('key1000368') }}</Button>
    </div>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "questionnaireModal",
  mixins: [Mixin],
  data() {
    return {
      questionnaireModal: false,
      questionnaireList: [],
      questionnaireInfo: {},
      answerStarttime: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    if (window.location.href.includes('ticket=')) {
      this.getQuestionnaireData();
    }
  },
  methods: {
    // 记录问卷访问量
    visitedQuestionnaire(ymsQuestionnaireId) {
      let v = this;
      v.axios.get(api.get_ymsQuestionnaire_api_visitedQuestionnaire + ymsQuestionnaireId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
        }
      });
    },
    // 获取调研问卷的数据
    getQuestionnaireData() {
      let v = this;
      v.axios.get(api.get_ymsQuestionnaire_api_showQuestionnaire + v.userInfo.merchantId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            v.questionnaireModal = true;
            v.questionnaireInfo = data[0];
            v.answerStarttime = v.$uDate.getCurrentTime('fulltime');
            v.visitedQuestionnaire(v.questionnaireInfo.ymsQuestionnaireId);
            let list = data[0].ymsQuestionnaireQuestions;
            if (list && list.length > 0) {
              list.map((item) => {
                item.textareaValue = '';
                item.otherTypeText = '';
                item.radioValue = null;
                if (item.questionType !== 3) {
                  item.ymsQuestionnaireQuestionsItems.map((ele) => {
                    if (ele.otherType === 1) {
                      ele.itemContent = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000363');
                    }
                  });
                }
              });
              v.questionnaireList = list;
            }
          } else {
            v.questionnaireModal = false;
          }
        }
      });
    },
    // 处理提交的数据
    handlerSubmitData(value) {
      let v = this;
      let obj = {};
      let query = {
        ymsQuestionnaireId: v.questionnaireInfo.ymsQuestionnaireId,
        ymsQuestionnaireQuestionsAnswerList: []
      };
      for (let i = 0; i < v.questionnaireList.length; i++) {
        let item = v.questionnaireList[i];
        item.submitQuestionnaireContents = [];
        // 提交答题
        if (value) {
          // 单选
          if (item.questionType === 1) {
            if (item.mandatory === 1) {
              item.ymsQuestionnaireQuestionsItems.map((ele) => {
                if (ele.ymsQuestionnaireQuestionsItemId === item.radioValue && ele.otherType === 1) {
                  if (item.otherTypeText === '') {
                    v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
                    return false;
                  }
                }
              });
            }
            item.ymsQuestionnaireQuestionsItems.map((ele) => {
              if (ele.ymsQuestionnaireQuestionsItemId === item.radioValue) {
                item.submitQuestionnaireContents.push({
                  itemContent: ele.otherType === 1 ? item.otherTypeText : ele.itemContent,
                  otherType: ele.otherType,
                  ymsQuestionnaireQuestionId: ele.ymsQuestionnaireQuestionId,
                  ymsQuestionnaireQuestionsItemId: item.radioValue
                });
              }
            });
          }
          // 多选
          if (item.questionType === 2) {
            if (item.mandatory === 1) {
              if (!item.answerContent) {
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
                return false;
              } else {
                if (item.answerContent.length <= 0) {
                  v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
                  return false;
                } else {
                  let list = item.ymsQuestionnaireQuestionsItems;
                  for (let i = 0; i < list.length; i++) {
                    let ele = list[i];
                    if (item.answerContent.includes(ele.ymsQuestionnaireQuestionsItemId) && ele.otherType === 1) {
                      if (item.otherTypeText === '') {
                        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
                        return false;
                      }
                    }
                  }
                }
              }
            }
            item.ymsQuestionnaireQuestionsItems.map((ele) => {
              if (item.answerContent && item.answerContent.includes(ele.ymsQuestionnaireQuestionsItemId)) {
                item.submitQuestionnaireContents.push({
                  itemContent: ele.otherType === 1 ? item.otherTypeText : ele.itemContent,
                  otherType: ele.otherType,
                  ymsQuestionnaireQuestionId: ele.ymsQuestionnaireQuestionId,
                  ymsQuestionnaireQuestionsItemId: ele.ymsQuestionnaireQuestionsItemId
                });
              }
            });
          }
          // 文本
          if (item.questionType === 3) {
            if (item.mandatory === 1 && item.textareaValue === '') {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
              return false;
            }
            item.submitQuestionnaireContents.push({
              itemContent: item.textareaValue,
              otherType: 0,
              ymsQuestionnaireQuestionId: item.ymsQuestionnaireQuestionId,
            });
          }
          query.ymsQuestionnaireQuestionsAnswerList.push({
            answerMerchantId: v.userInfo.merchantId,
            answerd: 1, // 问卷结果: 未答题 0 已答题 1
            visited: 1, // 浏览状态 1 已浏览
            ymsQuestionnaireId: item.ymsQuestionnaireId,
            answerStarttime: v.answerStarttime,
            answerEndtime: v.$uDate.getCurrentTime('fulltime'),
            ymsQuestionnaireQuestionId: item.ymsQuestionnaireQuestionId,
            submitQuestionnaireContents: item.submitQuestionnaireContents
          });
        }
        // 跳过
        else {
          query.ymsQuestionnaireQuestionsAnswerList.push({
            submitQuestionnaireContents: [],
            answerMerchantId: v.userInfo.merchantId,
            answerd: 0, // 问卷结果: 未答题 0 已答题 1
            visited: 1, // 浏览状态 1 已浏览
            ymsQuestionnaireId: item.ymsQuestionnaireId,
            ymsQuestionnaireQuestionId: item.ymsQuestionnaireQuestionId
          });
        }
      }
      if (value) {
        obj = {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')};
      }
      v.axios.post(api.post_ymsQuestionnaire_api_submitQuestionnaire, query, obj).then((res) => {
        if (res.data.code === 0) {
          v.questionnaireModal = false;
          if (value) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          } else {
            setTimeout(() => {
              v.getQuestionnaireData();
            }, 200);
          }
        }
      });
    },
    // 提交按钮
    submitBtn() {
      let v = this;
      v.handlerSubmitData(true);
    },
    // 跳过按钮
    skipBtn() {
      this.handlerSubmitData(false);
    },
    //切换单选
    radioChange(value) {
      let v = this;
      v.questionnaireList.map((item, index) => {
        if (item.questionType !== 3) {
          item.ymsQuestionnaireQuestionsItems.map((ele) => {
            if (ele.ymsQuestionnaireQuestionsItemId === value) {
              if (ele.otherType === 1) {
                v.$set(v.questionnaireList[index], 'otherTypeText', '');
                setTimeout(() => {
                  v.$set(v.questionnaireList[index], 'otherTalg', true);
                }, 300);
              } else {
                v.$set(v.questionnaireList[index], 'otherTalg', false);
              }
            }
          });
        }
      });
      v.$forceUpdate();
    },
    // 切换复选框
    checkBoxChange(list, ymsQuestionnaireQuestionId) {
      let v = this;
      v.questionnaireList.map((item, index) => {
        if (item.ymsQuestionnaireQuestionId === ymsQuestionnaireQuestionId) {
          item.otherTalg = false;
          item.ymsQuestionnaireQuestionsItems.map((ele) => {
            if (list && list.length > 0) {
              if (ele.otherType === 1) {
                if (list.includes(ele.ymsQuestionnaireQuestionsItemId)) {
                  item.otherTypeText = '';
                  v.$set(v.questionnaireList[index], 'otherTalg', true);
                } else {
                  v.$set(v.questionnaireList[index], 'otherTalg', false);
                }
                v.$forceUpdate();
              }
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .questionnaireStyle {
  padding: 20px;

  .content_box {
    width: 100%;
    height: 600px;
    overflow-y: auto;

    .header_title {
      text-align: center;
      margin-bottom: 15px;
      color: #000;
      font-size: 18px;
      font-weight: bold;
    }

    .text {
      color: #666;
      font-size: 14px;
    }

    .list_box {
      width: 100%;
      padding-bottom: 25px;

      .list_box_item {
        display: flex;
        flex-direction: column;
        margin-top: 25px;

        .title {
          color: #333333;
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: 600;
        }

        .required_styles:before {
          content: '*';
          display: inline-block;
          margin-right: 4px;
          line-height: 1;
          font-family: SimSun;
          font-size: 12px;
          color: #ed4014;
          position: relative;
          top: -4px;
        }

        .ivu-checkbox-default, .ivu-radio-default {
          margin: 0 30px 15px 0;
        }

        .input_error_style {
          .ivu-input {
            border: 1px solid #ed4014;
          }
        }

        .ivu-checkbox-wrapper {
          font-size: 14px !important;
        }
      }
    }
  }

  .options_btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>